import { createRootRoute, Outlet } from '@tanstack/react-router'

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: () => (
    <main className="not-found">
      <p className="eyebrow">Lost between panels?</p>
      <h1>This page is outside the story.</h1>
      <a className="button button--primary" href="/">
        Return to Volume 1
      </a>
    </main>
  ),
})
